import { AlertCircle, CheckCircle2, Info, TriangleAlert } from 'lucide-react';
import type { HTMLAttributes } from 'react';
import { cn } from '../../lib/utils';

type AlertKind = 'info' | 'success' | 'warning' | 'error';

interface AlertProps extends HTMLAttributes<HTMLDivElement> {
  kind?: AlertKind;
}

const icons = {
  info: Info,
  success: CheckCircle2,
  warning: TriangleAlert,
  error: AlertCircle,
};

export function Alert({ kind = 'info', className, children, ...props }: AlertProps) {
  const Icon = icons[kind];
  return (
    <div
      className={cn('alert', `alert-${kind}`, className)}
      role={kind === 'error' ? 'alert' : 'status'}
      {...props}
    >
      <Icon aria-hidden="true" size={20} />
      <div>{children}</div>
    </div>
  );
}
